import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles<Theme>((theme: Theme) => {
  return {
    formContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      paddingLeft: '158px',
      width: '100%',
      backgroundColor: theme.palette.background.default,
    },
    formTitle: {
      marginTop: '45px',
      marginBottom: '28px',
    },
    form: {
      width: '398px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'spaceEvenly',
      alignItems: 'center',
      paddingRight: '34px',
      paddingLeft: '34px',
      paddingBottom: '48px',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '12px',
    },
    formElements: {
      width: '100%',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-around',
      marginBottom: '8px',
    },
    formInput: {
      marginBottom: '28px',
    },
    submitButton: {
      display: 'block',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    forgotPassword: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '12px',
      marginTop: 20,
      padding: 20,
      width: 398,
      justifyContent: 'space-around',
    },
    oktaButton: {
      display: 'inline-flex',
      alignItems: 'center',
      marginTop: '10px',
      padding: '6px 16px 6px 12px',
    },
    oktaLogoStyle: {
      width: '24px',
      marginRight: '12px',
    },
    helperText: {
      position: 'absolute',
      top: '53px',
    },
    loginError: {
      marginTop: '8px',
      marginLeft: '8px',
    },
    oktaLoginError: {
      display: 'flex',
      textAlign: 'center',
    },
    loginMessage: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: theme.palette.background.paper,
      borderRadius: '12px',
      marginTop: 20,
      padding: 20,
      width: 398,
    },
  };
});

export default useStyles;
